import { Multiplayer } from "./constants";
import { GameMode } from "./game";
import { getVersionNumber } from "./version";

export function isSaveFromThisVersion(save: { version?: number }) {
	return save.version === getVersionNumber();
}

//The readers below are for clients, saves are kept in their localStorage

export function readContinuableSoloSave(): GameMode | null {
	const save = readSave(Multiplayer.AutosaveName) as { players?: Array<{ isBot: boolean }> } | null;
	if (!save || !Array.isArray(save.players)) return null;
	const humans = save.players.filter(player => !player?.isBot).length;
	if (humans > 1) return null;
	//A ranked game's replay opponent is saved along with it
	return save.players.some(player => player?.isBot) ? GameMode.Asynchronous : GameMode.Solo;
}

export function readContinuableMultiplayerSave() {
	return readSave(Multiplayer.MultiplayerAutosaveName) as { hostTransport?: 'steam' | 'browser' | null } | null;
}

function readSave(name: string) {
	const raw = localStorage.getItem(name);
	if (!raw) return null;
	try {
		const save = JSON.parse(raw);
		return isSaveFromThisVersion(save) ? save : null;
	}
	catch (error) {
		console.error(`Could not read the saved game ${name}`, error);
		return null;
	}
}
